export enum ClientsRoutes {
  root = 'clients',
  create = 'create',
}
